import { render, staticRenderFns } from "./Admin-Login.vue?vue&type=template&id=5f45e25d&scoped=true"
import script from "./Admin-Login.vue?vue&type=script&lang=js"
export * from "./Admin-Login.vue?vue&type=script&lang=js"
import style0 from "./Admin-Login.vue?vue&type=style&index=0&id=5f45e25d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f45e25d",
  null
  
)

export default component.exports